import { Component, inject, Input, signal } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthzService } from '../../core/auth/authz.service';
import { AsyncPipe } from '@angular/common';
import { TAuthProvider } from '../../core/auth/auth.interface';
import { AuthFacade } from '../../core/auth/auth.facade';
import { Router } from '@angular/router';
// RxJS
import { catchError, exhaustMap, filter, finalize, Subject, take, tap, throwError } from 'rxjs';
// Service
import { LoggingService } from '../../core/utils/logging.service';
// Directive
import { ProdHiddenElementDirective } from '../../core/directive/prod-hidden-element.directive';
// PrimeNG
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-link-account',
  imports: [AsyncPipe, ProdHiddenElementDirective, ImageModule, ButtonModule],
  templateUrl: './link-account.component.html',
  styleUrl: './link-account.component.scss',
})
export class LinkAccountComponent {
  @Input({ required: true }) redirectUrl!: string;
  @Input({ required: true }) socialProvider!: TAuthProvider;

  readonly auth0 = inject(AuthService);
  readonly authzService = inject(AuthzService);
  private readonly authFacade = inject(AuthFacade);
  readonly router = inject(Router);
  private readonly loggingService = inject(LoggingService);

  private linkBtnClickS$ = new Subject<boolean>();

  imgConnectingSignal = signal<string>('assets/icons/icon-line-green.png');

  constructor() {
    this.loggingService.error('@@@Constructor', this.redirectUrl);
  }

  linkAccount$ = this.linkBtnClickS$.pipe(
    tap(() => this.loggingService.log('linkAccount clicked')),
    exhaustMap(() => {
      return this.auth0.user$.pipe(
        filter((user): user is NonNullable<typeof user> => user != null),
        take(1),
        exhaustMap((user) => this.authzService.linkAccount(user.sub!, this.socialProvider)),
        finalize(() => {
          // * set state to force reload after redirect
          this.authFacade.updatePageRenderState({
            isFirstLoadAfterLinkAccount: true,
          });
          const url = new URL(this.redirectUrl);
          this.router.navigateByUrl(url.pathname);
        })
      );
    }),
    catchError((err) => {
      this.loggingService.error('Error linking account \n\n', err);
      return throwError(() => err);
    })
  );

  linkAccount() {
    this.linkBtnClickS$.next(true);
  }
}
